import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const textAreaDefaultVariants = {
  "size": "md",
  "error": false,
  "warning": false,
  "success": false,
  "hasEndAdornment": false
}
const textAreaCompoundVariants = []

const textAreaSlotNames = [
  [
    "root",
    "textArea__root"
  ],
  [
    "textAreaContainer",
    "textArea__textAreaContainer"
  ],
  [
    "textArea",
    "textArea__textArea"
  ],
  [
    "endAdornment",
    "textArea__endAdornment"
  ]
]
const textAreaSlotFns = /* @__PURE__ */ textAreaSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, textAreaDefaultVariants, getSlotCompoundVariant(textAreaCompoundVariants, slotName))])

const textAreaFn = memo((props = {}) => {
  return Object.fromEntries(textAreaSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const textAreaVariantKeys = [
  "size",
  "error",
  "warning",
  "success",
  "hasEndAdornment"
]
const getVariantProps = (variants) => ({ ...textAreaDefaultVariants, ...compact(variants) })

export const textArea = /* @__PURE__ */ Object.assign(textAreaFn, {
  __recipe__: false,
  __name__: 'textArea',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: textAreaVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "error": [
    "true"
  ],
  "warning": [
    "true"
  ],
  "success": [
    "true"
  ],
  "hasEndAdornment": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, textAreaVariantKeys)
  },
  getVariantProps
})